import type { KeyboardEvent, ReactNode } from "react";
import { SparklineChart, type SparklinePoint } from "@/components/charts/SparklineChart";
import { TrendBadge } from "@/components/charts/TrendBadge";

interface StatCardProps {
  label: string;
  value: string;
  trendDelta?: number;
  sparklineData?: SparklinePoint[];
  sparklineColor?: string;
  children?: ReactNode;
  onClick?: () => void;
}

export function StatCard({
  label,
  value,
  trendDelta,
  sparklineData,
  sparklineColor,
  children,
  onClick,
}: StatCardProps) {
  const clickableProps = onClick
    ? {
        role: "link" as const,
        tabIndex: 0,
        onKeyDown: (event: KeyboardEvent<HTMLDivElement>) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            onClick();
          }
        },
      }
    : {};

  return (
    <div
      className={`stat-card${onClick ? " stat-card-clickable" : ""}`}
      onClick={onClick}
      {...clickableProps}
    >
      <span className="stat-card-label">{label}</span>
      <div className="stat-card-value-row">
        <span className="stat-card-value">{value}</span>
        {trendDelta !== undefined ? <TrendBadge delta={trendDelta} /> : null}
      </div>
      {children}
      {sparklineData && sparklineData.length > 0 ? (
        <div className="stat-card-chart">
          <SparklineChart data={sparklineData} color={sparklineColor} />
        </div>
      ) : null}
    </div>
  );
}
